import { render, staticRenderFns } from "./ContractComponent.vue?vue&type=template&id=fa0dd46a&scoped=true"
import script from "./ContractComponent.vue?vue&type=script&lang=js"
export * from "./ContractComponent.vue?vue&type=script&lang=js"
import style0 from "./ContractComponent.vue?vue&type=style&index=0&id=fa0dd46a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0dd46a",
  null
  
)

export default component.exports